import { CommonRequestOptions, makeRequest } from '~/monolith-api/makeRequest';

export const LOGIN_BY_EMAIL = 'EMAIL';
export const LOGIN_BY_USERNAME = 'USERNAME';

export type GetCourseStageSignoffRequestResult = {
   signoffRequest: {
      signoff_requestid: number;
      stage_assementid: number;
      initializeSignoffViaSSOUrl: null | string;
      requestor: {
         userid: number;
         username: string;
         unique_username: string;
         login_by: typeof LOGIN_BY_EMAIL | typeof LOGIN_BY_USERNAME;
         email_or_unique_username: string;
         profileUrl: string;
         avatarUrl: string;
      };
      requestee: {
         userid: number;
         username: string;
         unique_username: string;
         email_or_unique_username: string;
         login_by: typeof LOGIN_BY_EMAIL | typeof LOGIN_BY_USERNAME;
         profileUrl: string;
         avatarUrl: string;
      };
      work_log_entryid: number;
      created_at: number;
      stage: {
         course_stageid: number;
         title: string;
         docid: number;
         doctype: string;
         doc_url: string;
      };
   };
};

export type GetCourseStageSignoffRequestOptions = CommonRequestOptions & {
   signoff_requestid: number;
   course_assignmentid: number;
};

export async function getCourseStageSignoffRequest({
   signoff_requestid,
   course_assignmentid,
   ...common
}: GetCourseStageSignoffRequestOptions): Promise<GetCourseStageSignoffRequestResult> {
   return makeRequest(
      'get',
      `/courses/stage-sign-offs/requests/${signoff_requestid}/${course_assignmentid}`,
      common
   );
}
